import { isValidLegalName, LEGAL_NAME_FORMAT_MESSAGE } from './legalName'
import { isValidLegalEntityInn } from './inn'

export type VenueFormField = 'inn' | 'legalName' | 'tradeName' | 'city'

export type VenueFormFieldErrors = Partial<Record<VenueFormField, string>>

export type VenueFormValues = {
  inn: string
  legalName: string
  tradeName: string
  city: string
  /** Не показываем в UI; передаём с бэка / дефолтом при создании. */
  horecaType: string
}

export const hasVenueFormErrors = (errors: VenueFormFieldErrors): boolean =>
  Object.keys(errors).length > 0

export const validateVenueForm = (values: VenueFormValues): VenueFormFieldErrors => {
  const errors: VenueFormFieldErrors = {}

  if (!values.inn.trim()) {
    errors.inn = 'Введите ИНН'
  } else if (!isValidLegalEntityInn(values.inn.trim())) {
    errors.inn = 'ИНН юридического лица должен содержать 10 цифр'
  }
  if (!values.legalName.trim()) {
    errors.legalName = 'Введите юридическое название'
  } else if (!isValidLegalName(values.legalName)) {
    errors.legalName = LEGAL_NAME_FORMAT_MESSAGE
  }
  if (!values.tradeName.trim()) {
    errors.tradeName = 'Введите торговое название'
  }
  if (!values.city.trim()) {
    errors.city = 'Выберите город'
  }

  return errors
}
